import React, { Fragment } from "react";
import Container from "react-bootstrap/Container";
import "./TermsTab.css";

const Miscellaneous = (props) => {
  return (
    <Fragment>
      <div className="tc main-pad py-md-5 py-4">
        <h3> Intellectual Property </h3>
        <ul>
          <li>
            {" "}
            In the case of contest which require Participants to submit
            audio/video recordings Participants grant to Classic Mall
            Development Island Star Mall Developers Pvt Ltd Pvt. Ltd the
            unconditional and irrevocable right to broadcast the audio/video
            recording(s) submitted by Participants by live or deferred
            transmission in all formats (including, without limitation,
            analogue, digital, internet, cable, satellite and telephony
            broadcasts, social media etc). This shall include the right to
            alter, edit and compile the audio recording in any way whatsoever.
            Participants confirm that the use by of the audio/video recording
            submitted does not infringe any third party rights and shall
            indemnify Classic Mall Development Island Star Mall Developers Pvt
            Ltd Pvt. Ltd for any loss, damage or liability arising in connection
            therewith.{" "}
          </li>
          <li>
            {" "}
            Participants who submit audio/video recordings represent and warrant
            that they have the right, power and authority to grant the rights
            set out above and that they have obtained all consents and
            permissions in respect of the same.
          </li>
          <li>
            {" "}
            For the avoidance of doubt, all rights in the name and title of the
            Contest and the format rights for the Contest will vest exclusively
            in Classic Mall Development Island Star Mall Developers Pvt Ltd Pvt.
            Ltd for its own use in its absolute discretion.
          </li>
        </ul>
        <br />
        <br />
        <h3>
          Island Star Mall Developers Pvt Ltd Pvt. Ltd – exclusion of liability
        </h3>
        <ul>
          <li>
            {" "}
            is not liable in any way for any costs, expenses, damages, liability
            or injury arising out of or in any way connected with the contest or
            prizes other than those costs and expenses specifically provided for
            in the prize (if any).{" "}
          </li>
          <li>
            {" "}
            accepts no liability (and excludes all liability) for any loss of
            profit, business, contracts, revenues or anticipated savings or for
            special, direct, indirect or consequential loss of any nature
            howsoever arising.
          </li>
          <li>
            {" "}
            shall not be liable to perform any of its obligations under the
            contest or in respect of the prizes where it is unable to do so as a
            result of circumstances beyond its control or due to force Majeure
            events including but not limited to fire, accident, riots, flood,
            earthquake, storm, terrorist activities, war, Act of God or any
            order, circular regulation of any government or governmental agency,
            pandemic etc. and shall not be liable to compensate Participants in
            such circumstances.
          </li>
        </ul>
        <p>
          You agree to defend, indemnify, and hold the Classic Mall Development
          Island Star Mall Developers Pvt Ltd Pvt. Ltd, its officers, directors,
          employees and agents, harmless from and against any claims,
          liabilities, damages, losses, and expenses, including without
          limitation reasonable attorney’s fees and costs, arising out of or in
          any way connected with (i) your access to or use of the Application or
          Services; (ii) your violation of the Terms; or (iii) your violation of
          any third party right, including without limitation any intellectual
          property right, publicity, confidentiality, property or privacy right.
          <br />
          <br />
          Failure by Us to insist upon strict performance of any provision of
          this or any Agreement or the failure by Us to exercise any right or
          remedy to which we are entitled hereunder shall not constitute a
          waiver thereof and shall not cause a diminution of the obligations
          under this or any Agreement.
        </p>
      </div>
    </Fragment>
  );
};

export default Miscellaneous;
